import { FormattersTypes } from '@/services/types/formatter'


export default ({ vtag, data, key }: FormattersTypes) => {
  if(data[key].indexOf('fa fa-bank') != -1)
  return vtag('div', {class:{'class-name': true}},
      [ vtag('ui-icon', {props:{size: 12, icon: 'fa fa-university', color: 'var(--color-gray50)' }}),
      data[key].replace('<i class="fa fa-bank"></i>', ' ') ] );
  
  if(data[key].indexOf('fa fa-sitemap') != -1)
    return vtag('div', {class:{'class-name': true}},
      [ vtag('ui-icon', {props: { size: 12, icon: 'fas fa-sitemap', color: 'var(--color-gray50)' }}),
      data[key].replace('<i class="fa fa-sitemap"></i>', ' ') ] );
  
  if(data[key].indexOf('fa fa-briefcase') != -1)
    return vtag('div', {class:{'class-name': true}},
      [ vtag('ui-icon', {props:{size: 12, icon: 'fas fa-briefcase', color: 'var(--color-gray50)' }}),
      data[key].replace('<i class="fa fa-briefcase"></i>', ' ') ] );
  
  if(data[key].indexOf('fa fa-globe') != -1)
    return vtag('div', {class:{'class-name': true}},
      [ vtag('ui-icon', {props:{size: 12, icon:'fas fa-globe', color: 'var(--color-gray50)'}}),
      data[key].replace('<i class="fa fa-globe"></i>', ' ') ] );
  
  if(data[key].indexOf('fa fa-laptop') != -1)
    return vtag('div', {class:{'class-name': true}},
      [ vtag('ui-icon', {props:{size: 12, icon: 'fas fa-laptop', color: 'var(--color-gray50)'}}),
      data[key].replace('<i class="fa fa-laptop"></i>', ' ') ] );

  if(data[key].indexOf('fa fa-internet-explorer') != -1)
    return vtag('div', {class:{'class-name': true}},
      [ vtag('ui-icon', {props:{size: 12, icon: 'fab fa-internet-explorer', color: 'var(--color-gray50)'}}),
      data[key].replace('<i class="fa fa-internet-explorer"></i>', ' ') ] );
  
  if(data[key].indexOf('fa fa-wifi') != -1)
    return vtag('div', {class:{'class-name': true}},
      [ vtag('ui-icon', {props:{size: 12, icon: 'fas fa-wifi', color: 'var(--color-gray50)'}}),
      data[key].replace('<i class="fa fa-wifi"></i>', ' ') ] );
  
  if(data[key].indexOf('fa fa-windows') != -1)
  return vtag('div', {class:{'class-name': true}},
      [ vtag('ui-icon', {props:{size: 12, icon:'fab fa-windows', color: 'var(--color-gray50)'}}),
      data[key].replace('<i class="fa fa-windows"></i>', ' ') ] );

  if(data[key].indexOf('fa fa-code') != -1)
  return vtag('div', {class:{'class-name': true}},
      [ vtag('ui-icon', {props:{size: 12, icon:'fas fa-code', color: 'var(--color-gray50)'}}),
      data[key].replace('<i class="fa fa-code"></i>', ' ') ] );
  
  if(data[key].indexOf('fa fa-external-link') != -1)
  return vtag('div', {class:{'class-name': true}},
      [ vtag('ui-icon', {props:{size: 12, icon: 'fas fa-external-link-alt', color: 'var(--color-gray50)'}}),
      data[key].replace('<i class="fa fa-external-link"></i>', ' ') ] );

  
  if(data[key] = 'Empty')
    return vtag('div', {class:{'class-name': true}}, 'Empty' )
}
